<!-- 项目文件 -->
<template>
    <div>
        <Header :Logo="logo" ref="mychild" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p  pb30">
            <div class="pt60  overflow pb30 alit w1200 mauto">
                <div class="w400 floatl disinblock ">
                    <div class="">
                        <div class="posre">
                            <P class="bttit fs36 c333 pb8">中心化频道开放</P>
                        </div>
                        <div class="fs16 c333 pt25 lh25 ">
                            <P>一起分享e学e驾中心化频道触达用户机会，</P>
                            <p>开屏、e学e驾首页、理论学习、在线约课、发现频道、</p>
                            <p>会员频道、学车商城等更多的频道逐步开放。</p>
                        </div>
                    </div>
                </div>
                <div class="w800 pl20 floatl disinblock posre h400">

                        <p class="disinblock posab top0 left120 textc opacity_5 hov_opac cursor" :class="{'opacity1':isOpacity==1}" @mousemove="move(1)" @mouseout ="out()" >
                            <img class="w84 h84" src="../../public/img/img306.png" alt="">
                            <span class="disblock c333 fs16">e学e驾首页</span>
                        </p>
                        <p class="disinblock  posab top80 left0 textc opacity_5 hov_opac cursor" :class="{'opacity1':isOpacity==2}" @mousemove="move(2)" @mouseout ="out()">
                            <img class="w84 h84" src="../../public/img/img306_1.png" alt="">
                            <span class="disblock c333 fs16">开屏</span>
                        </p>
                        <p class="disinblock  posab top140 left120 textc opacity_5 hov_opac cursor" :class="{'opacity1':isOpacity==3}" @mousemove="move(3)" @mouseout ="out()">
                            <img class="w84 h84" src="../../public/img/img306_2.png" alt="">
                            <span class="disblock c333 fs16">理论学习</span>
                        </p>
                        
                        <div class="l300 posab top0 left0">
                            
                            <p class="opacity0  posab top0 left0" :class="{'opacity1':isOpacity==1}">
                                <img class="w220 h400" src="../../public/img/img317.jpg" alt="">
                            </p>
                            <p  class="opacity0 posab top0 left0":class="{'opacity1':isOpacity==2}">
                                <img class="w220 h400" src="../../public/img/img318.png" alt="">
                            </p> 
                            <p  class="opacity0 posab top0 left0" :class="{'opacity1':isOpacity==3}">
                                <img class="w220 h400" src="../../public/img/img319.jpg" alt="">
                            </p>
                            <p class="opacity0 posab top0 left0" :class="{'opacity1':isOpacity==4}">
                                <img class="w220 h400" src="../../public/img/img319.png" alt="">
                            </p>
                            <p  class="opacity0 posab top0 left0" :class="{'opacity1':isOpacity==5}">
                                <img class="w220 h400" src="../../public/img/img320.png" alt="">
                            </p>
                            <p  class="opacity0 posab top0 left0" :class="{'opacity1':isOpacity==6}">
                                <img class="w220 h400" src="../../public/img/img326.png" alt="">
                            </p>
                        </div>
                   
                        <p class="disinblock  posab top150 right120 textc opacity_5 hov_opac cursor" :class="{'opacity1':isOpacity==4}" @mousemove="move(4)" @mouseout ="out()">
                            <img class="w84 h84" src="../../public/img/img306_3.png" alt="">
                            <span class="disblock c333 fs16">在线约课</span>
                        </p>
                        <p class="disinblock  posab top215 right0 textc opacity_5 hov_opac cursor" :class="{'opacity1':isOpacity==5}" @mousemove="move(5)" @mouseout ="out()">
                            <img class="w84 h84" src="../../public/img/img306_4.png" alt="">
                            <span class="disblock c333 fs16">发现频道</span>
                        </p>
                        <p class="disinblock  posab top70  right0 textc opacity_5 hov_opac cursor" :class="{'opacity1':isOpacity==6}" @mousemove="move(6)" @mouseout ="out()">
                            <img class="w84 h84" src="../../public/img/img306_5.png" alt="">
                            <span class="disblock c333 fs16">会员频道</span>
                        </p>
                    
                </div>
            </div>

            <div class="pt50 w100p bgfsf9 pb30 mt20">
                
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                开放能力
                            </span>
                        </p>
                    </div>
                    <div class="mt30">
                        <ul class="overflow  disblock w1200 mauto pb20 pt10 textc">
                            <li class="textc w19p  disinblock pt20  pb20 pl20 pr20  box hov_li cursor">
                                <span class="disblock"><img class="w110 h110" src="../../public/img/img307.png" alt=""></span>
                                <span class="disblock pt30 pb20 fs20 c333 fbold">流量曝光</span>
                                <span class='disblock fs14 c999'>用户流量直达</span>
                                <span class='disblock fs14 c999'>迅速引爆流量</span>
                            </li>
                            <li class="textc w19p  disinblock pt20  pb20 pl20 pr20  box hov_li cursor">
                                <span class="disblock"><img class="w110 h110" src="../../public/img/img308.png" alt=""></span>
                                <span class="disblock pt30 pb20 fs20 c333 fbold">口令链接</span>
                                <span class='disblock fs14 c999'>直达营销热点</span>
                                <span class='disblock fs14 c999'>快速实现转化</span>
                            </li>
                            
                            <li class="textc w19p  disinblock pt20  pb20 pl20 pr20  box hov_li cursor">
                                <span class="disblock"><img class="w110 h110" src="../../public/img/img309.png" alt=""></span>
                                <span class="disblock pt30 pb20 fs20 c333 fbold">商户引流</span>
                                <span class='disblock fs14 c999'>直接触达用户</span>
                                <span class='disblock fs14 c999'>实现流量引入</span>
                            </li>
                            <li class="textc w19p  disinblock pt20  pb20 pl20 pr20  box hov_li cursor">
                                <span class="disblock"><img class="w110 h110" src="../../public/img/img310.png" alt=""></span>
                                <span class="disblock pt30 pb20 fs20 c333 fbold">单品直销</span>
                                <span class='disblock fs14 c999'>多种营销方式</span>
                                <span class='disblock fs14 c999'>打造营销爆款</span>
                            </li>
                            <li class="textc w19p  disinblock pt20  pb20 pl20 pr20  box hov_li cursor">
                                <span class="disblock"><img class="w110 h110" src="../../public/img/img311.png" alt=""></span>
                                <span class="disblock pt30 pb20 fs20 c333 fbold">流量裂变</span>
                                <span class='disblock fs14 c999'>营销裂变扩大销告渠过</span>
                                <span class='disblock fs14 c999'>提升销售业绩</span>
                            </li>

                        </ul>
                    </div>
               
            </div>

            <div class="overflow w1200 mauto pt50 pb30">
                <div class="textc mt20 mb20">
                    <p class="fs36 c333 disinblock posre">
                        <span class="border-bottom1">
                            行业案例
                        </span>
                    </p>
                </div>
                <div class="floatl w300  overflow h600 posre">
                    <transition name="fade22" mode="out-in">
                        <img v-if="showImg==1" class="imgauto" src="../../public/img/img321.png">
                    </transition>
                    <transition name="fade22" mode="out-in">
                        <img v-if="showImg==2" class="imgauto" src="../../public/img/img322.png">
                    </transition>
                    <transition name="fade22" mode="out-in">
                        <img v-if="showImg==3" class="imgauto" src="../../public/img/img323.png">
                    </transition>
                    <transition name="fade22" mode="out-in">
                        <img v-if="showImg==4" class="imgauto" src="../../public/img/img324.png">
                    </transition>
                    <transition name="fade22" mode="out-in">
                        <img v-if="showImg==5" class="imgauto" src="../../public/img/img325.png">
                    </transition>

                
                </div>
                <div class="floatl  pt30 w900">
                    <div class="">
                        <p class="c333 fs30 pl64">会展</p>
                        <div class="w100p pl35">
                            <ul class="w100p disinblock ml-10">
                                <li @mousemove="moveImg(1)" class="disinblock w25p minh230 textc floatl box  pt35">
                                    <img class="w140 h140" src="../../public/img/img312.png">
                                    <p class="white fs16 c333 textc pt20">五一车展</p>
                                </li>
                                <li @mousemove="moveImg(2)" class="disinblock w25p minh230 textc floatl box  pt35">
                                    <img class="w140 h140" src="../../public/img/img313.png">
                                    <p class="white fs16 c333 textc pt20">EVCARD</p>
                                </li>
                                <li @mousemove="moveImg(3)" class="disinblock w25p minh230 textc floatl box  pt35">
                                    <img class="w140 h140" src="../../public/img/img314.png">
                                    <p class="white fs16 c333 textc pt20">安心·百万医疗</p>
                                </li>
                                <li @mousemove="moveImg(4)" class="disinblock w25p minh230 textc floatl box  pt35">
                                    <img class="w140 h140" src="../../public/img/img315.png">
                                    <p class="white fs16 c333 textc pt20">单个商品</p>
                                </li>
                
                                <li @mousemove="moveImg(5)" class="disinblock w25p minh230 textc floatl box  pt35">
                                    <img class="w140 h140" src="../../public/img/img316.png">
                                    <p class="white fs16 c333 textc pt20">特价新车</p>
                                </li>
 
                            </ul>
                        </div>
                    </div>
                </div>
                   
            </div>
            <div class="pt60 pb30 textc pb20">
                <span @click="openChild()" class="cfff cursor bg1f8 bradius5 fs18 disinblock fbold h50 lh50 w240">合作申请</span>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    export default {
        data() {
            return {
                bgImg: require('../../public/img/img87.png'),
                titleList: 3,
                link: 1,
                logo: 'coop',
                color: 2,
                isOpacity: 1,
                timer: null,
                showImg: 1,
            };
        },
        components: {
            Header,
            Footer,

        },
        methods: {
            openChild() {
                this.$refs.mychild.foo();
            },
            isShow() {
                let that = this;
                that.timer = setInterval(() => {
                    if (that.isOpacity > 5) {
                        that.isOpacity = 1;
                    } else {
                        that.isOpacity++;
                    }
                }, 1500);
            },
            move(id) {
                clearInterval(this.timer);
                this.isOpacity = id
            },
            out() {
                this.isShow()
            },
            moveImg(id) {
                this.showImg = id;
            },
        },
        created() {
            this.isShow()
        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bttit:before {
        content: '';
        position: absolute;
        left: 0;
        top: auto;
        bottom: 0;
        right: auto;
        height: 4px;
        width: 20px;
        background-color: #1f82f6;
    }
    
    .l300 {
        left: 300px;
    }
    
    .left120 {
        left: 120px;
    }
    
    .right120 {
        right: 120px;
    }
    
    .top215 {
        top: 215px;
    }
    
    .top80 {
        top: 80px;
    }
    
    .top140 {
        top: 140px;
    }
    
    .top70 {
        top: 70px;
    }
    
    .top150 {
        top: 150px;
    }
    
    .opacity_5 {
        opacity: 0.5
    }
    
    .hov_opac:hover {
        opacity: 1;
    }
    
    .opacity0 {
        opacity: 0;
    }
    
    .opacity1 {
        opacity: 1;
        transition: 0.5s;
    }
    
    .opacity1 span {
        font-weight: 600;
        color: #1f82f6;
    }
    
    .hov_li {
        transition: all 0.3s;
    }
    
    .hov_li:hover {
        background-color: #fff;
        -moz-box-shadow: 0px 0px 5px 5px #d8edfe;
        /* 老的 Firefox */
        box-shadow: 0px 0px 5px 5px #d8edfe;
    }
    
    .fade22-enter-active {
        transition: opacity 1s;
        position: absolute;
    }
    
    .fade22-enter,
    .fade22-leave-to {
        opacity: 0;
    }
</style>